module.exports = __webpack_public_path__ + "img/MiddleSide_Left.0cf854f2.jpg";